import React, { useEffect } from 'react';
import { Box, Button, Typography, Paper, Container } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../auth/authConfig';
import { APP_NAME, ROUTES } from '../utils/constants';

export const Login: React.FC = () => {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (accounts.length > 0 && inProgress === 'none') {
      navigate(ROUTES.DASHBOARD);
    }
  }, [accounts, inProgress, navigate]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.error('Login error:', error);
    });
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            {APP_NAME}
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Sign in with your Microsoft account to access the admin portal
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleLogin}
            fullWidth
            sx={{ mt: 2 }}
          >
            Sign in with Microsoft
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};
